export default __webpack_public_path__ + "ed2389bcf72aac4c3fb329fdb6772ccc.jpg";